export default "__VITE_ASSET__08fe8129__"